export default __webpack_public_path__ + "static/media/app-bar-image.700caad6.png";